import payoutType from './revenuePayoutTypes'

const initialState = {
  isLoading: false,
  searching: false,
  filtering: false,
  downloading: false,
  approving: false,
  search: [],
  myReferrals: {},
  allRevenuePayout: {},
  singleRevenuePayout: {},
};

export default function revenuePayoutReducer(state = initialState, action) {
  switch (action.type) {
    case payoutType.LOADING_REVENUE_PAYOUT:
      return {
        ...state,
        isLoading: action.payLoad,
      };

    case payoutType.GET_MY_REVENUE_PAYOUT:
      return {
        ...state,
        myReferrals: action.payLoad?.data,
      };

    case payoutType.ALL_REVENUE_PAYOUT:
      return {
        ...state,
        allReferrals: action.payLoad?.data,
      };

    case payoutType.SHOW_REVENUE_PAYOUT:
      return {
        ...state,
        singleRevenuePayout: action.payLoad?.data,
      };

    case payoutType.SEARCHING:
      return {
        ...state,
        searching: action.payLoad,
      };

    case payoutType.SEARCH_REVENUE_PAYOUT:
      return {
        ...state,
        search: action.payLoad,
      };

    case payoutType.FILTERING_REVENUE_PAYOUT:
      return {
        ...state,
        filtering: action.payLoad,
      };

    case payoutType.FILTER_REVENUE_PAYOUT:
      return {
        ...state,
        allRevenuePayout: action.payLoad?.data,
      };

    case payoutType.DOWNLOADING:
      return {
        ...state,
        downloading: action.payLoad,
      };

    case payoutType.APPROVING_REVENUE_PAYOUT:
      return {
        ...state,
        approving: action.payLoad,
      };

    default:
      return state;
  }
}
